import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => ({
  summaryWrapperBox: {
    position: 'sticky',
    top: 90,
  },
  container: {
    borderRadius: 10,
    backgroundColor: `rgba(${hexToRgb(theme.palette.blue.efesLightBlue)}, 0.03)`,
    padding: ({ isDeviceMdSize }) => (isDeviceMdSize ? '' : '10px'),
    marginTop: 30,
  },
  bottomSheet: {
    zIndex: 1301,
    position: 'absolute',
  },
  sectionTitle: {
    fontSize: 20,
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
    },
  },
  contractDetailsTitle: {
    marginTop: '.5rem',
    marginBottom: '.5rem',
  },
  buyButton: {
    width: '100% !important',
    marginTop: '.5rem',
  },
  buyButtonBox: {
    paddingTop: '0 !important',
  },
  toggleText: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '.8rem',
  },
  amountPrice: {
    textWrap: 'nowrap',
  },
  sectionRow: {
    paddingLeft: 20,
    paddingTop: 20,
    paddingBottom: 20,
    [theme.breakpoints.down('lg')]: {
      padding: '10px 0',
    },
  },
  unsetPaddingLeft: {
    paddingLeft: 0,
  },
  basketDetails: {
    paddingLeft: 0,
    paddingBottom: 0,
  },
  promoCodesRow: {
    paddingTop: 0,
  },
  summaryTotal: {
    borderRadius: 8,
    justifyContent: 'space-between',
    background: theme.palette.white.efesBackgroundLight,
    color: theme.palette.black.main,
    fontWeight: 'bolder',
    borderColor: 'none',
    padding: 20,
    marginBottom: 20,
    [theme.breakpoints.down('lg')]: {
      marginTop: 0,
      marginBottom: 16,
    },
  },
  summaryTotalLabel: {
    fontSize: '1.2rem',
  },
  summaryTotalAmount: {
    fontSize: '1.5rem',
    height: '1.5rem',
  },
  travelers: {
    wordBreak: 'auto-phrase',
  },
  travelersCount: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  policySummaryContainer: {
    width: '100%',
  },
  agreement: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  agreementText: {
    fontSize: 18,
    textAlign: 'justify',
  },
  agreementTextMobile: {
    fontSize: 12,
    textAlign: 'justify',

  },
  agreementLabel: {
    fontSize: 18,
    display: 'flex',
  },
  agreementLabelDisabled: {
    opacity: 0.5,
  },
  mobileSummaryCheckbox: {
    display: 'flex',
  },
  attachedWrapper: {
    border: `1px solid ${theme.palette.gray.efesGrayAlt}`,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 10,
  },
  sectionBox: {
    marginLeft: 30,
  },
}));

export default useStyles;
